<template>
  <div>
    <aside
      ref="sidebar"
      v-click-outside="onClickOutsideSidebarDesktop"
      class="left-side-menu hide-scrollbar"
      :class="`${$vuetify.breakpoint.width < 768 && expanded ? 'is-expanded is-expanded-mobile' : $vuetify.breakpoint.width >= 768 && expanded ? 'is-expanded' : '' }`"
      style="z-index: 2;"
    >
      <div class="left-side-menu__content">
        <span class="logo d-md-flex align-items-center justify-content-between">
          <router-link 
            v-if="authUser.is_manager"
            :to="{ name: PRE_DASHBOARD_ROUTE_NAME }"
          >
            <img
              src="/images/logo_nitro.svg"
              alt="Nitro Logo"
              style="width: auto; height: 26px;"
            >
          </router-link>
          <img
            v-else
            src="/images/logo_nitro.svg"
            alt="Nitro Logo"
          >
          <button
            v-if="$vuetify.breakpoint.width > 767"
            id="sidebar-toggle"
            class="d-flex justify-center align-center"
            @click="onClickToggleSideBarDesktop"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15.88"
              height="7.84"
            >
              <use xlink:href="#icon-expand" />
            </svg>

          </button>

        </span>
        <!-- <svg
          xmlns="http://www.w3.org/2000/svg"
          class="icon-expand hide-expanded mb-4 d-none d-md-block"
        >
          <use xlink:href="#icon-expand" />
        </svg> -->
        <div v-if="user">
          <StudentMenu v-if="user.is_student" />
        </div>
      </div>

      <!-- === Sidebar Footer Start ===  -->
      <div class="nav-user">
        <div class="nav-user__block">
          <IconUserInitials :full-name="user.name" />
          <div
            v-if="$store.state.navbar_expanded"
            class="nav-user__content show-expanded d-flex flex-column justify-content-center mb-2"
          >
            <h3 class="avatar-name mb-0 text-wrap mb-1">
              {{ user.name }}
              <router-link
                v-if="user.is_manager"
                class="d-inline text-nitro mt-1"
                :to="{ name: USER_CONFIG_ROUTE_NAME }"
              >
                <i class="fas fa-cog" />
              </router-link>
            </h3>
            <!-- <p class="mb-0">{{$user->school->name}}</p>-->
            <span
              v-if="user.is_student"
              class="text-wrap"
            >
              {{ user.grade_name }}
            </span>
            <span
              v-if="user.is_student && user.group_name"
              class="text-wrap"
            >
              {{ user.group_name.toLowerCase().includes('turma') ? user.group_name : `Turma ${user.group_name }` }}
            </span>
            <span
              v-if="user.is_student"
              class="text-wrap"
            >
              RA {{ user.ra }} / RE {{ user.re }}
            </span>
            <span
              v-if="user.is_student && user.school"
              class="mt-1 text-wrap"
            >
              {{ user.school.name }}
            </span>
          </div>
        </div>
      </div>
    </aside>
    <!-- === Sidebar Mobile Bar ===  -->
    <mobile-bar :toggle-menu="onClickToggleSidebarMobile" />
  </div>
</template>
<script>
import IconUserInitials from '@/common/components/IconUserInitials'
import MobileBar from '@/common/components/sidebar/MobileBar'
import StudentMenu from '@/student/components/sidebar/StudentMenu'
import { logout } from '../../utils/logout'
import { mapActions, mapGetters } from 'vuex'
import {PRE_DASHBOARD_ROUTE_NAME, USER_CONFIG_ROUTE_NAME} from "@/school/constants/routes"


export default {
  components: {
    StudentMenu,
    MobileBar,
    IconUserInitials
  },
  data() {
    return {
      USER_CONFIG_ROUTE_NAME,
      PRE_DASHBOARD_ROUTE_NAME,
    }
  },
  computed: {
    ...mapGetters(['authUser']),
    user() {
      return this.$store.getters.authUser
    },
    expanded() {
      return this.$store.state.navbar_expanded
    },
  },
  mounted() {
    //Hacky
    this.$root.$on("outsideMobile", () => {
      this.onClickOutsideSidebarMobile();
    });
  },
  methods: {
    ...mapActions(['isLoading']),
    logout,
    onClickToggleSidebarMobile() {
      this.$store.state.navbar_expanded = !this.$store.state.navbar_expanded
    },
    onClickToggleSideBarDesktop() {
      const refSidebar = this.$refs.sidebar;
      if (refSidebar.style.width != "320px") {
        this.openMenu(refSidebar);
      }
      else {
        this.closeMenu(refSidebar);
      }

    },
    onClickOutsideSidebarDesktop() {
      const refSidebar = this.$refs.sidebar;
      if (this.$vuetify.breakpoint.width >= 768) {
        this.closeMenu(refSidebar);
      }
    },
    onClickOutsideSidebarMobile() {
      const refSidebar = this.$refs.sidebar;
      if (this.$vuetify.breakpoint.width < 768) {
        this.closeMenu(refSidebar);
      }
    },
    openMenu() {
      const refSidebar = this.$refs.sidebar;
      this.$store.state.navbar_expanded = true;
      refSidebar.style.width = "320px";
    },
    closeMenu(refSidebar) {
      this.$store.state.navbar_expanded = false;
      refSidebar.style.width = "80px";
    },
  },

}

</script>

